import React, { Component } from "react";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import {Alert, Button, Col, Row} from "react-bootstrap";
import FieldGroup from "../../components/FieldGroup";
import API from "../../services/API";

class PeerclickCampaignUpdate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            campaignId: null,
            oldOfferId: null,
            newOfferId: null,
            message: "",
            messageStyle: ""
        }

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ isLoading: true })
        const { campaignId, oldOfferId, newOfferId } = this.state;

        if(!campaignId) return this.setState({ isLoading: false, message: "Campaign ID is required.", messageStyle: 'danger'})
        if(!oldOfferId) return this.setState({ isLoading: false, message: "Old Offer ID is required.", messageStyle: 'danger'})
        if(!newOfferId) return this.setState({ isLoading: false, message: "New Offer ID is required.", messageStyle: 'danger'})

        API.PeerclickCampaign.update(campaignId, oldOfferId, newOfferId)
            .then(({ response, error }) => {
                if(error) {
                    this.setState({ isLoading: false, message: error, messageStyle: 'danger'})
                }

                if(response) {
                    this.setState({ isLoading: false, message: "Updated successfully.", messageStyle: 'success'})
                }
            })
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Peerclick Campaign Update"/>

                <form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col lg={4}>
                            <FieldGroup
                                name="campaignId"
                                label="Campaign id:"
                                onChange={this.handleFieldChange}
                                value={this.state.campaignId}
                            />
                        </Col>
                        <Col lg={4}>
                            <FieldGroup
                                name="oldOfferId"
                                label="Old offer id:"
                                onChange={this.handleFieldChange}
                                value={this.state.oldOfferId}
                            />
                        </Col>
                        <Col lg={4}>
                            <FieldGroup
                                name="newOfferId"
                                label="New offer id:"
                                onChange={this.handleFieldChange}
                                value={this.state.newOfferId}
                            />
                        </Col>
                    </Row>

                    {
                        this.state.message && <Alert bsStyle={this.state.messageStyle}>{this.state.message}</Alert>
                    }

                    <Button type="submit" bsStyle="success" className="m-b-15" >Update</Button>
                </form>
            </Container>
        )
    }
}

export default PeerclickCampaignUpdate;



// WEBPACK FOOTER //
// ./src/scenes/PeerclickCampaignUpdate/index.js